/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */

import { Grid } from "antd";
import React from "react";
import DesktopMainMenu from "./DesktopMainMenu";
import MobileMainMenu from "./MobileMainMenu";

// Main menu
export const MainMenu = (props) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { xl } = screens;
  if (xl) {
    return <DesktopMainMenu {...props} />;
  }
  return <MobileMainMenu {...props} />;
};

export default MainMenu;
